import axiosInstance from "./config";

const ROUTE = "/client/forms";

export const checkFormFillStatusRequest = async () =>
  axiosInstance
    .get(`${ROUTE}/check-form-status/`)
    .then((response) => response.data);

export const createFormRequest = async (requestData) =>
  axiosInstance
    .post(`${ROUTE}/form-submission/`, requestData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);

export const createCustomFieldsAnswers = async (requestData) =>
  axiosInstance
    .post(`${ROUTE}/custom-fields-answers/`, requestData)
    .then((response) => response.data);
